import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { finalize, Observable, throwError } from 'rxjs';
import { dasa } from 'src/classess/dasaClasses';

@Injectable()
export class DasaInterceptor implements HttpInterceptor {
  constructor( ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // show loader for all active requests
    dasa.Utility.showBusy();
    //const nonce = this.generateNonce();
  //const timestamp = this.getTimestamp();
    const modifiedReq = req.clone({
      setHeaders: {}
      // setHeaders: {
      //   'X-Nonce': nonce,
      //   'X-Timestamp': timestamp.toString()
      // }
    });

    return next.handle(modifiedReq).pipe(finalize(() => dasa.Utility.hideBusy()));
  }
  generateNonce(length: number = 16): string {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (dec) => ('0' + dec.toString(16)).substr(-2)).join('');
  }

  getTimestamp(): number {
    return Math.floor(Date.now() / 1000); // Get current timestamp in seconds
  }
  }

